import React from 'react'
import InquiryLayout from './InquiryLayout'
import SideNavLayout from 'src/components/layouts/SideNavLayout/SideNavLayout'

const InquiryLayoutWrapper = () => {
  return (
    <SideNavLayout>
        <InquiryLayout/>
    </SideNavLayout>
  )
}

export default InquiryLayoutWrapper